import { useState } from "react";
import { Chakra } from "@airhelp/react-ui-components";
import Card from "./CardDesktop";
import type { CardMobileProps } from "./CardMobile";

const { SimpleGrid } = Chakra;

export interface CardsItemDesktop extends CardMobileProps {
  _uid: string;
}

export interface CardsDesktopProps {
  cards: CardsItemDesktop[];
  cardsHeightDesktop: string;
}

const CardsDesktop = ({ cards, cardsHeightDesktop }: CardsDesktopProps) => {
  const [{ heading: firstCardHeader }] = (cards.length && cards) || [{ heading: "" }];
  const [openCard, setOpenCard] = useState(firstCardHeader);

  return (
    <SimpleGrid columns={cards.length % 2 ? { base: 1, lg: 3 } : { base: 2, lg: 2, xl: 4 }} spacing={8}>
      {cards.map(({ heading, text, icon, subHeading, _uid }) => (
        <Card
          key={_uid}
          heading={heading}
          text={text}
          icon={icon}
          setOpenCard={setOpenCard}
          openCard={openCard}
          cardsHeightDesktop={cardsHeightDesktop}
          subHeading={subHeading}
        />
      ))}
    </SimpleGrid>
  );
};

export default CardsDesktop;
